<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import { Helper } from '@/mixin/helper'

import datePickerLang from '@/helpers/date-picker-lang'
import { authComputed } from '@/state/helpers'

import Multiselect from 'vue-multiselect'
import McBadge from '@/components/McBadge'
import McButton from '@/components/McButton'

import { GET_VEHICLE_DOCS, UPDATE_VEHICLE_DOCS } from '@/services/api/license/vehicleDocs'

moment.locale('id')

export default {
  components: {
    Multiselect,
    McBadge,
    McButton,
  },
  mixins: [Helper],
  apollo: {
    vehicleDocs: {
      query: GET_VEHICLE_DOCS,
      variables() {
        return {
          filter: {
            status: ['E', 'AE', 'V', 'N'],
          },
        }
      },
      result({ data, loading }) {
        if (!loading) {
          this.initPage(data.vehicleDocs.vehicleDocs)
        }
      },
    },
  },
  props: {
    docType: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      inPhase: true,
      selected: {
        fleetDocument: [],
      },
      selectedModel: {
        fleetDocument: [],
      },
      allSelected: {
        fleetDocument: false,
      },
      indeterminate: {
        fleetDocument: true,
      },
      filterStatus: {
        all: true,
        kadaluarsa: false,
        akanKadaluarsa: false,
        berlaku: false,
        tidakTerdefinisi: false,
      },
      fleetDocsFilteredData: [],
      vehicleDocs: {
        vehicleDocs: [],
      },
      licensePlate: null,
      documentName: null,
      status: null,
      fav: null,
      show_model: null,
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],

      form: {
        vehicleDocs: [],
      },
      filteredItems: [],
      isSort: false,
    }
  },

  computed: {
    ...authComputed,
    ...mapGetters({
      isNewSubmodule: 'identity/isNewSubmodule',
      hasAccess: 'identity/hasAccess',
    }),
    /**
     * Total no. of records
     */
    rows() {
      return this.filteredItems.length
    },

    totalTrue() {
      return this.selectedModel.fleetDocument.filter((c) => c === true)
    },

    datePickerLang() {
      return datePickerLang()
    },

    fleetDocument() {
      return [
        {
          key: 'licensePlate',
          label: this.$t('global.object.licensePlate'),
          thClass: 'mc-table--50',
          sortable: true,
        },
        {
          key: 'docType',
          label: this.$t('license.object.documentName'),
          thClass: 'mc-table--50',
          sortable: true,
        },
        {
          key: 'docNumber',
          label: this.$t('license.object.documentNo'),
          thClass: 'mc-table--50',
          sortable: true,
        },
        {
          key: 'validUntil',
          label: this.$t('license.object.validUntil'),
          thClass: 'mc-table--50',
          sortable: true,
        },
        {
          key: 'status',
          label: 'Status',
          thClass: 'mc-table--50',
          sortable: true,
        },
      ]
    },

    oldData() {
      return { vehicleDocs: this.vehicleDocs.vehicleDocs }
    },

    visibleFields() {
      if (this.show_model && this.show_model.length > 0) {
        var result = this.show_model.map((a) => a.key)

        return this.fleetDocument.filter(function (item) {
          return item.key == 'licensePlate' || result.includes(item.key)
        })
      } else {
        return this.fleetDocument
      }
    },

    show() {
      return [
        { key: 'docType', label: this.$t('license.object.documentName') },
        { key: 'docNumber', label: this.$t('license.object.documentNo') },
        { key: 'validUntil', label: this.$t('license.object.validUntil') },
        { key: 'status', label: 'Status' },
      ]
    },

    statusName() {
      return {
        E: this.$t('license.filter.expired'),
        AE: this.$t('license.filter.willExpired'),
        V: this.$t('license.filter.valid'),
      }
    },
  },

  mounted() {
    // Set the initial number of items
    this.totalRows = this.filteredItems.length ?? 0
    this.$store.commit('license/SET_DOCTYPE', this.docType)
    this.$apollo.queries.vehicleDocs.refetch()
  },

  methods: {
    focusSearch() {
      this.$refs.searchInput.focus()
    },
    initPage(data) {
      var docs = data || []
      var resDocs = []
      var self = this
      docs.forEach(function (item, index) {
        resDocs.push({
          ...item,
          id: index + 1,
          type: 'data',
          statusName: item.status
            ? self.statusName[item.status]
            : self.$t('license.object.unidentified'),
          validUntilLabel: item.validUntil || '-',
        })
      })
      this.form.vehicleDocs = resDocs
      this.filteredItems = resDocs
    },

    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.filteredItems = filteredItems
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },

    toSave() {
      let promises = []
      var self = this

      var vehicleChange = this.form.vehicleDocs.filter((item) => item.type == 'form')
      vehicleChange.forEach(function (item) {
        if (Object.prototype.hasOwnProperty.call(item, 'oldExpired')) {
          promises.push(
            self.$apollo.mutate({
              mutation: UPDATE_VEHICLE_DOCS,
              variables: {
                input: {
                  vehicleId: parseInt(item.vehicleId),
                  docType: item.docType,
                  docNumber: item.docNumber,
                  validUntil: item.validUntil,
                },
              },
            })
          )
        }
      })

      Promise.all(promises).then(() => {
        this.$apollo.queries.vehicleDocs.refetch()
        this.$mcToast.success(this.$t('global.alert.text.saved'))
        this.isSort = false
      })
    },

    updateFilterStatus(param) {
      Object.keys(this.filterStatus).forEach((key) => {
        this.filterStatus[key] = false
      })

      this.filterStatus[param] = true
      this.filterByStatus()
    },

    async filterByStatus() {
      var status = []

      if (this.filterStatus.all) {
        status = ['E', 'AE', 'V', 'N']
      } else if (this.filterStatus.berlaku) {
        status = ['V']
      } else if (this.filterStatus.kadaluarsa) {
        status = ['E']
      } else if (this.filterStatus.akanKadaluarsa) {
        status = ['AE']
      } else if (this.filterStatus.tidakTerdefinisi) {
        status = ['N']
      }

      await this.$apollo.queries.vehicleDocs.refetch({
        filter: {
          status: status,
        },
      })

      this.form.vehicleDocs = [...this.form.vehicleDocs]
      this.filteredItems = [...this.form.vehicleDocs]
    },

    onRowClicked(data, i) {
      // const index = (this.currentPage - 1) * this.perPage + i;
      if (data.docType) {
        this.isSort = true
        var id = data.id
        if (data.type != 'form') {
          const index = this.filteredItems.findIndex((item) => item.id == id)

          this.filteredItems[index].type = 'form'
          this.filteredItems[i].oldExpired = data.validUntil
          data.oldExpired = data.validUntil
        } else {
          const index = this.filteredItems.findIndex((item) => item.id == id)

          this.filteredItems[index].type = 'data'
          this.filteredItems[i].validUntil = data.oldExpired
          data.validUntil = data.oldExpired
          this.checkStatus(i)
        }
      } else {
        this.$mcToast.warning(this.$t('license.swal.noFleetDocument'))
      }
    },

    checkStatus(index) {
      const today = new Date()
      const zeroPad = (num, places) => String(num).padStart(places, '0')
      const date =
        today.getFullYear() +
        '-' +
        zeroPad(today.getMonth() + 1, 2) +
        '-' +
        zeroPad(today.getDate(), 2)

      if (date > this.form.vehicleDocs[index].validUntil) {
        this.form.vehicleDocs[index].status = 'E'
        this.form.vehicleDocs[index].statusName = this.statusName['E']
      } else {
        const range = this.getDatesInRange(date, this.form.vehicleDocs[index].validUntil).length
        if (range <= 30) {
          this.form.vehicleDocs[index].status = 'AE'
          this.form.vehicleDocs[index].statusName = this.statusName['AE']
        } else {
          this.form.vehicleDocs[index].status = 'V'
          this.form.vehicleDocs[index].statusName = this.statusName['V']
        }
      }
    },
  },
}
</script>

<template>
  <b-tab active class="border-0" @click="$store.commit('license/SET_DOCTYPE', docType)">
    <template #title>
      <span class="d-inline-block d-sm-none"> {{ $t('license.object.vehicleDocument') }} </span>
      <span class="d-none d-sm-inline-block">{{ $t('license.object.vehicleDocument') }}</span>
      <McBadge
        v-if="isNewSubmodule('b5b-lisensi-kendaraan')"
        variant="danger"
        size="small"
        type="notif"
        class="mx-1"
      />
    </template>

    <div class="row">
      <div class="col-md-12">
        <div class="mc-table-filter__status pb-4">
          <McButton
            size="sm"
            class="me-2"
            :variant="filterStatus.all ? 'secondary' : 'outline'"
            :text="$t('global.filter.all')"
            @click="updateFilterStatus('all')"
          />
          <McButton
            size="sm"
            class="me-2"
            :variant="filterStatus.kadaluarsa ? 'secondary' : 'outline'"
            :text="$t('license.filter.expired')"
            @click="updateFilterStatus('kadaluarsa')"
          />
          <McButton
            size="sm"
            class="me-2"
            :variant="filterStatus.akanKadaluarsa ? 'secondary' : 'outline'"
            :text="$t('license.filter.willExpired')"
            @click="updateFilterStatus('akanKadaluarsa')"
          />
          <McButton
            size="sm"
            class="me-2"
            :variant="filterStatus.berlaku ? 'secondary' : 'outline'"
            :text="$t('license.filter.valid')"
            @click="updateFilterStatus('berlaku')"
          />
          <McButton
            size="sm"
            class="me-2"
            :variant="filterStatus.tidakTerdefinisi ? 'secondary' : 'outline'"
            :text="$t('license.object.unidentified')"
            @click="updateFilterStatus('tidakTerdefinisi')"
          />
        </div>
      </div>
      <div v-if="!inPhase" class="col-md-4 text-end">
        <div class="mc-table-filter">
          <a
            v-b-modal.modal-filter-fleet
            class="popup-form btn btn-outline-primary"
            href="javascript: void(0);"
          >
            <i class="mc-fa bx bx-filter-alt" />
            {{ 'Filter' }}
          </a>
          <b-modal
            id="modal-filter-fleet"
            class="mc-modal"
            title="Filter"
            size="lg"
            centered
            scrollable
          >
            <div class="card-body mc-modal__filter">
              <form>
                <div class="mc-modal__filter-item">
                  <label class="mt-3">{{ $t('global.object.licensePlate') }}</label>
                  <multiselect
                    v-model="licensePlate"
                    :options="['L 1234 CVB', 'L 2345 UIP', 'L 5678 POI']"
                    :multiple="true"
                    :placeholder="$t('global.object.licensePlate')"
                  />
                </div>
                <div class="mc-modal__filter-item">
                  <label class="mt-3">{{ $t('license.object.documentName') }}</label>
                  <multiselect
                    v-model="documentName"
                    :options="['STNK', 'BPKB']"
                    :multiple="true"
                    :placeholder="$t('license.action.selectDocument')"
                  />
                </div>
                <div class="mc-modal__filter-item">
                  <b-form-group v-slot="{ ariaDescribedby }" label="Status">
                    <b-form-checkbox-group
                      id="checkbox-group-1"
                      v-model="selected"
                      :options="['Kedaluwarsa', 'Akan Kedaluwarsa', 'Berlaku']"
                      :aria-describedby="ariaDescribedby"
                      name="flavour-1"
                    />
                  </b-form-group>
                </div>
              </form>
            </div>
            <template #modal-footer="{ cancel }">
              <b-row class="mc-modal__filter-footer">
                <b-col md="12">
                  <p class="mc-modal__filter-footer-info">
                    {{ $t('global.text.displays') }} <strong>2 data</strong>
                    {{ $t('global.object.filterResult') }}
                    <a href="#">
                      <i class="mc-fa fas fa-redo"></i>
                      {{ $t('license.action.readjust') }}
                    </a>
                  </p>
                </b-col>

                <b-col sm="12" md="6" class="mc-modal__filter-footer-fav">
                  <label>{{ $t('global.object.favorite') }}</label>
                  <multiselect
                    v-model="fav"
                    :options="['Over Speed - Aceh', 'Over Speed - Demak', 'Over Speed - Manado']"
                    placeholder="Favorit"
                    class="w-50"
                  />
                </b-col>

                <b-col sm="12" md="6" class="mc-modal__filter-footer-btn">
                  <b-button class="me-3" variant="outline-primary" @click="cancel()">
                    {{ $t('global.action.cancel') }}
                  </b-button>
                  <b-button variant="primary">
                    {{ $t('global.action.apply') }}
                  </b-button>
                </b-col>
              </b-row>
            </template>
          </b-modal>
        </div>
      </div>
    </div>

    <div class="row">
      <!-- Search -->
      <div class="col-sm-12 col-md-12">
        <div class="mc-table-view float-end">
          <p class="mc-label">{{ $t('global.action.show') }}</p>
          <multiselect
            v-model="show_model"
            :options="show"
            :multiple="true"
            :placeholder="$t('global.object.allColumn')"
            track-by="label"
            label="label"
          />
          <div id="tickets-table_filter" class="dataTables_filter text-md-end">
            <label
              class="d-inline-flex align-items-center mc-table-view__search"
              @click="focusSearch"
            >
              <i class="mc-fa fas fa-search"></i>
              <b-form-input
                ref="searchInput"
                v-model="filter"
                type="search"
                :placeholder="$t('global.search') + '...'"
                class="form-control ms-2"
              />
            </label>
          </div>
        </div>
      </div>
      <!-- End search -->
    </div>

    <!-- Table -->
    <div class="table-responsive my-3 border border-1">
      <b-table
        small
        show-empty
        :fields="visibleFields"
        :items="form.vehicleDocs"
        class="datatables"
        responsive="md"
        empty-table
        :empty-text="$t('global.emptyTable')"
        :empty-filtered-text="$t('global.emptyFilteredTable')"
        :per-page="perPage"
        :current-page="currentPage"
        :filter="filter"
        :filter-included-fields="filterOn"
        :no-local-sorting="isSort"
        @filtered="onFiltered"
      >
        <template #cell(licensePlate)="data">
          <strong
            v-if="hasAccess('vehicle_docs:update')"
            class="text-primary"
            @click="onRowClicked(data.item, data.index)"
          >
            {{ data.item.licensePlate }}
          </strong>
          <span v-else>{{ data.item.licensePlate }}</span>
        </template>

        <template #cell(docType)="data">
          <span>
            {{ data.item.docType }}
          </span>
        </template>

        <template #cell(docNumber)="data">
          <b-form-input
            v-if="data.item.type == 'form'"
            v-model="filteredItems[(currentPage - 1) * perPage + data.index].docNumber"
            trim
            :placeholder="`${$t('global.form.enter')} Nomor Dokumen`"
          />
          <span v-else>
            {{ data.item.docNumber }}
          </span>
        </template>

        <template #cell(validUntil)="data">
          <date-picker
            v-if="data.item.type == 'form'"
            v-model="filteredItems[(currentPage - 1) * perPage + data.index].validUntil"
            format="DD MMM YYYY"
            value-type="YYYY-MM-DD"
            placeholder="Tanggal"
            :lang="datePickerLang"
            @input="checkStatus(data.index)"
          />
          <span v-else>
            {{ data.item.validUntil ? momentDateShortMonth(data.item.validUntil) : '-' }}
          </span>
        </template>

        <template #cell(status)="data">
          <div>
            <span v-if="data.item.status == 'E'" class="mc-status mc-status--red">{{
              $t('license.filter.expired')
            }}</span>
            <span v-else-if="data.item.status == 'AE'" class="mc-status mc-status--yellow">{{
              $t('license.filter.willExpired')
            }}</span>
            <span v-else-if="data.item.status == 'V'" class="mc-status mc-status--green">{{
              $t('license.filter.valid')
            }}</span>
            <span v-else>{{ $t('license.object.unidentified') }}</span>
          </div>
        </template>
      </b-table>
    </div>

    <div class="row">
      <div class="col-sm-12 col-md-6">
        <div id="tickets-table_length" class="dataTables_length">
          <label class="d-inline-flex align-items-center">
            {{ $t('global.text.displays') }}
            <b-form-select
              v-model="perPage"
              class="form-select form-select-sm"
              size="sm"
              :options="pageOptions"
            />
            {{ $t('global.text.entries') }}.
            <p>
              {{ $t('global.text.display') }}&nbsp;<strong>{{
                filteredItems.length > 0 ? (currentPage - 1) * perPage + 1 : 0
              }}</strong>
              - <strong>{{ Math.min(filteredItems.length, currentPage * perPage) }}</strong
              >&nbsp;{{ $t('global.object.of') }}&nbsp;<strong>{{ filteredItems.length }}.</strong>
            </p>
          </label>
        </div>
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="dataTables_paginate paging_simple_numbers float-end">
          <ul class="pagination pagination-rounded mb-0">
            <!-- pagination -->
            <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" />
          </ul>
        </div>
      </div>
    </div>
  </b-tab>
</template>
